<script setup lang="ts">
import { ChevronDownIcon } from "tir-style-system/icons/outline";

/**Параметры */
defineProps({
  /**Видимость складной панели*/
  isVisible: { type: Boolean, default: false },
});
/**События */
const emit = defineEmits<{
  /**Событие переключения видимости складной панели */
  toggle: [];
}>();

/**Переключение видимости складной панели */
const toggle = () => {
  emit("toggle");
};
</script>

<template>
  <div class="tir-pm-fold-panel">
    <div class="tir-pm-fold-panel__header" @click="toggle">
      <slot name="header" />
      <ChevronDownIcon
        class="tir-pm-fold-panel__icon"
        :class="{ 'tir-pm-fold-panel__icon--open': isVisible }"
      />
    </div>
    <transition name="fold">
      <div v-show="isVisible" class="tir-pm-fold-panel__content">
        <slot name="content" />
      </div>
    </transition>
  </div>
</template>

<style scoped lang="scss">
.tir-pm-fold-panel {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }
  &__icon {
    width: 1.5rem;
    height: 1.5rem;
    transition: transform 0.2s ease;
    &--open {
      transform: rotate(180deg);
    }
  }
  &__content {
    overflow: hidden;
    transition: height 0.2s ease;
  }
}
.fold-enter-active,
.fold-leave-active {
  transition: all 0.3s ease;
  transform-origin: top;
}

.fold-enter-from,
.fold-leave-to {
  transform: scaleY(0);
  opacity: 0;
}

.fold-enter-to,
.fold-leave-from {
  transform: scaleY(1);
  opacity: 1;
}
</style>
